import React from "react";

import {Controller} from "react-hook-form";
import ReactHookFormDropdownChildSiblings from "root/ReactHookForm/ui/ReactHookFormDropdownChildSiblings";
import PropTypes from "prop-types";

const DropdownChildSiblings = ({ validate, control, name, readOnly, options }) =>
{
    return (
        <Controller
            control={control}
            name={name}
            rules={{ required: true, validate: validate}}
            render={({field: { onChange, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState,}) => (
                <ReactHookFormDropdownChildSiblings name={name} onChange={onChange} value={value} inputRef={ref} options={options} readOnly={readOnly}/>
            )}/>
    )
}

export default DropdownChildSiblings ;

DropdownChildSiblings.propTypes = {
    name: PropTypes.string.isRequired
};